import { Redirect, Route, useRouteMatch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import ParentWrapper from "../../components/ParentWrapper";
import PrivateRoute from "../../components/PrivateRoute";
import ClientExternalNotification from "../ClientExternalNotification/ClientExternalNotification";

const queryClient = new QueryClient();

const ParentConsole = () => {
  let { path } = useRouteMatch();
  return (
    <QueryClientProvider client={queryClient}>
      <ParentWrapper path={path}>
        <PrivateRoute exact path={`${path}/notification`}>
          <ClientExternalNotification />
        </PrivateRoute>
        <Route>
          <Redirect to={`${path}/notification`} />
        </Route>
      </ParentWrapper>
    </QueryClientProvider>
  );
};

export default ParentConsole;
